import { LANGUAGE } from '@/types/commonConst';

import type { MessageMap } from '..';

export const commonMessages = {
  BY_AI: {
    [LANGUAGE.EN]: 'Generated by AI',
  },
} as const satisfies MessageMap;
